import { getCompanyGroupList, getPeopleGroupList } from "@/api/contact";
import { getIsAccessDisabled } from "@/utils/permissions";
import { PEOPLE_TYPE, COMPANY_TYPE } from "@/views/search/constants";

const state = {
  companySavedList: [],
  peopleSavedList: [],
  savedListPeopleFilter: {
    type: PEOPLE_TYPE,
    name: "",
    is_ascending_order: false,
  },
  savedListCompanyFilter: {
    type: COMPANY_TYPE,
    name: "",
    is_ascending_order: false,
  },
  savedListPromise: {},
  savedListLoading: {},

  companies_saved_list_access_code: null,
  people_saved_list_access_code: null,
};

const mutations = {
  set_companies_saved_list_access_code(state, payload) {
    state.companies_saved_list_access_code = payload;
  },
  set_people_saved_list_access_code(state, payload) {
    state.people_saved_list_access_code = payload;
  },
  setCompanyList(state, payload) {
    state.companySavedList = payload;
  },
  setPeopleList(state, payload) {
    state.peopleSavedList = payload;
  },
  setSavedListPeopleFilter(state, payload) {
    state.savedListPeopleFilter = {
      ...state.savedListPeopleFilter,
      ...payload,
    };
  },
  setSavedListCompanyFilter(state, payload) {
    state.savedListCompanyFilter = {
      ...state.savedListCompanyFilter,
      ...payload,
    };
  },
  setSavedListPromise(state, { type, promise }) {
    state.savedListPromise = { ...state.savedListPromise, [type]: promise };
  },
  setSavedListLoading(state, { type, loading }) {
    state.savedListLoading = { ...state.savedListLoading, [type]: loading };
  },
};

const actions = {
  async getSavedList({ commit, state, rootState }, data = {}) {
    const { type, forceRefresh = false, ...rest } = data;
    let access_code = null;
    switch (type) {
      case PEOPLE_TYPE:
        access_code = state.people_saved_list_access_code;
        break;
      case COMPANY_TYPE:
        access_code = state.companies_saved_list_access_code;
        break;
    }
    if (getIsAccessDisabled(access_code)) {
      return;
    }
    let savedList;
    let setListMutation;
    let getListApi;

    if (type === PEOPLE_TYPE) {
      savedList = state.peopleSavedList;
      setListMutation = "setPeopleList";
      getListApi = getPeopleGroupList;
    } else if (type === COMPANY_TYPE) {
      savedList = state.companySavedList;
      setListMutation = "setCompanyList";
      getListApi = getCompanyGroupList;
    } else {
      console.error("Invalid type provided to getSavedList");
      return Promise.reject("Invalid type");
    }

    if (savedList.length > 0 && !forceRefresh) {
      return Promise.resolve(savedList);
    }

    if (state.savedListPromise[type] && !forceRefresh) {
      return state.savedListPromise[type];
    }

    const params = {
      profile_id: rootState.user.currentId.profile_id,
      ...rest,
    };

    const promise = getListApi(params)
      .then((result) => {
        if (result && result.data) {
          commit(setListMutation, result.data);
          commit("setSavedListPromise", { type, promise: null });
          return result.data;
        }
      })
      .catch((err) => {
        commit("setSavedListPromise", { type, promise: null });

        const code = err?.response?.data?.code;
        switch (type) {
          case PEOPLE_TYPE:
            commit("set_people_saved_list_access_code", +code);
            break;
          case COMPANY_TYPE:
            commit("set_companies_saved_list_access_code", +code);
            break;
        }
        throw err;
      })
      .finally(() => {
        commit("setSavedListLoading", { type, loading: false });
      });

    commit("setSavedListPromise", { type, promise });
    commit("setSavedListLoading", { type, loading: true });

    return promise;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
